import { API_ENDPOINT } from "../constants/endpoints";
import axios from "../config/axios";

const fetcher = async (url) => axios.get(`${API_ENDPOINT}${url}`).then((res) => res.data);

export default fetcher;
